<template>
    <article class="p-6 lg:p-12 flex gap-6 group items-start border-b border-dark-grey -mb-px">
        <figure class="relative basis-[100px] md:basis-[40%] shrink-0">
            <a :href="item.permalink" class="block w-full aspect-square bg-gray-100! relative">
                <Image :src="item.post_thumbnail" class="w-full h-full object-cover absolute" />
            </a>
        </figure>
        <div class="grid gap-2">
            <a :href="`?media_type=${ item.media_type.term_id }`" class="text-yellow inline-flex gap-2 uppercase items-center hover:opacity-50 hover:text-yellow!">
                <component :is="getIconComponent" :item="item" class="size-4" aria-hidden="true" />
                <span>{{ item.media_type.name }}</span>
            </a>
            <p class="font-header uppercase text-lg leading-none m-0!">
                <a :href="item.permalink" class="text-white hover:text-yellow! hover:underline! hover:decoration-1!">{{ item.post_title }}</a>
            </p>

            <div>
                <a :href="`?project=${ item.project.term_id }`" class="tag flex gap-1 items-center bg-[#CEA06D]! text-dark-green! hover:bg-yellow!">{{ item.project.name }}</a>
            </div>

            <div>
                <a :href="`?theme=${ item.theme.term_id }`" class="leading-tight uppercase text-md text-white hover:text-yellow! hover:underline! hover:decoration-1!" v-html="item.theme.name"></a>
            </div>

            <div class="flex gap-2 items-center mt-2">
                <a
                    :href="item.permalink"
                    class="uppercase py-1 px-3 border text-yellow border-dark-grey rounded-3xl hover:bg-yellow! hover:text-dark-green! hover:border-yellow!"
                    >Info</a
                >
            </div>
        </div>
    </article>
</template>

<script setup>
import { computed } from "vue";
import { SpeakerWaveIcon, VideoCameraIcon, CameraIcon, PencilIcon } from "@heroicons/vue/24/outline";
import Image from "../../global/Image.vue";

const { item } = defineProps({
    item: {
        type: Object,
        required: true,
    },
});

const getIconComponent = computed(() => {
    return {
        audio: SpeakerWaveIcon,
        video: VideoCameraIcon,
        photography: CameraIcon,
        writing: PencilIcon,
    }[item.media_type.slug];
});

</script>
